import axios from 'axios'
export function queryDropDownBox (data) {
  return axios.get(`/manage/warehouse/queryDropDownBox`, { params: data })
}
export function queryWmsStorageAreaDropDownBox (data) {
  return axios.get(`/manage/warehouse/queryWmsStorageAreaDropDownBox`, { params: data })
}
export function queryWmsStorageLocationDropDownBox (data) {
  return axios.get(`/manage/warehouse/queryWmsStorageLocationDropDownBox`, { params: data })
}
export function selectWmsTrayList (data) {
  return axios.get(`/manage/warehouse/selectWmsTrayList`, { params: data })
}
export function syncData (data) {
  return axios.get(`/manage/wms/syncData`, { params: data })
}